import React from 'react';

const Custom404: React.FC = () => {
  return (
    <div
      style={{
        fontFamily:
          'system-ui,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"',
        height: '100vh',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ lineHeight: '48px' }}>
        <h1
          style={{
            borderRight: '1px solid rgba(0,0,0,.3)',
            display: 'inline-block',
            margin: '0 20px 0 0',
            paddingRight: '23px',
            fontSize: '24px',
            fontWeight: '500',
            verticalAlign: 'top',
          }}
        >
          404
        </h1>

        <div style={{ display: 'inline-block' }}>
          <h2 style={{ fontSize: '14px', fontWeight: '400', lineHeight: '28px' }}>
            This page could not be found.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Custom404;
